/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState } from 'react';
import { Box, Button, Modal, TextField, Typography } from '@mui/material';
import { RECURRING_PAYABLE_STATUS, RECURRING_PAYABLE_STATUS as RP_STATUS } from 'modules/enumerations/enumerationIds';
import { isIdEqual } from 'modules/enumerations/enumerationHelpers';
import { getEffectiveStatus } from '../recurringPayableConstants';

const RecurringPayableDetailsButtons = ({
  isFormValidForApproval = false,
  rpInfoForm,
  rpInfo,
  isDirty = false,
  updateRecurringPayable,
  setRecurringPayableInfoForm,
  addOpen,
  expandedId
}) => {
  const [open, setOpen] = useState(false);
  const [denyReason, setDenyReason] = useState(rpInfoForm?.recurringPayableInformation?.denyReason || '');

  const effectiveStatus = getEffectiveStatus(rpInfoForm?.recurringPayableInformation);

  const pushStatus = async targetStatusId => {
    const next = {
      ...rpInfoForm,
      recurringPayableInformation: {
        ...rpInfoForm?.recurringPayableInformation,
        recurringPayableStatusId: targetStatusId,
        denyReason: isIdEqual(targetStatusId, RP_STATUS.CANCELLED) ? denyReason || '' : '',
        onHoldReason: ''
      }
    };
    await updateRecurringPayable(next);
  };

  const DraftView = (
    <Box sx={{ display: 'flex', gap: 1, justifyContent: 'flex-end', width: '100%' }}>
      <Button variant="contained" onClick={() => setRecurringPayableInfoForm(rpInfo)} disabled={!isDirty}>
        Cancel
      </Button>
      <Button variant="contained" onClick={() => updateRecurringPayable(rpInfoForm)} disabled={!isDirty}>
        Save Draft
      </Button>
      <Button variant="contained" onClick={() => pushStatus(RP_STATUS.PENDING)} disabled={!isFormValidForApproval || addOpen || !!expandedId}>
        Set As Pending
      </Button>
      <Button variant="contained" color="primary" onClick={() => pushStatus(RP_STATUS.ACTIVE)} disabled={!isFormValidForApproval || addOpen || !!expandedId}>
        Submit and Activate
      </Button>
    </Box>
  );

  const PendingOrHoldView = (
    <Box sx={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
      <Button variant="contained" onClick={() => setOpen(true)}>
        Deny
      </Button>

      <Box sx={{ display: 'flex', gap: 1 }}>
        <Button variant="contained" onClick={() => pushStatus(RP_STATUS.DRAFT)}>
          Reopen to Draft
        </Button>
        <Button variant="contained" onClick={() => setRecurringPayableInfoForm(rpInfo)} disabled={!isDirty}>
          Cancel
        </Button>
        <Button variant="contained" onClick={() => updateRecurringPayable(rpInfoForm)} disabled={!isDirty}>
          Save
        </Button>
        <Button variant="contained" color="primary" onClick={() => pushStatus(RP_STATUS.ACTIVE)} disabled={!isFormValidForApproval || addOpen || !!expandedId}>
          Activate
        </Button>
      </Box>

      <Modal open={open} onClose={() => setOpen(false)}>
        <Box sx={{ width: 500, p: 3, m: 'auto', mt: '20vh', bgcolor: 'white', borderRadius: 2 }}>
          <Typography variant="h6" sx={{ mb: 2 }}>
            Enter Deny Reason
          </Typography>
          <TextField fullWidth multiline rows={4} value={denyReason} onChange={e => setDenyReason(e.target.value)} />
          <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2 }}>
            <Button onClick={() => setOpen(false)}>Close</Button>
            <Button
              onClick={async () => {
                await pushStatus(RECURRING_PAYABLE_STATUS.CANCELLED);
                setOpen(false);
              }}
              variant="contained"
            >
              Save
            </Button>
          </Box>
        </Box>
      </Modal>
    </Box>
  );

  const DeniedView = (
    <Box sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', width: '100%', gap: 1, flexWrap: 'wrap' }}>
      <Button variant="contained" onClick={() => pushStatus(RP_STATUS.DRAFT)}>
        Reopen to Draft
      </Button>
      <Button variant="contained" onClick={() => pushStatus(RP_STATUS.PENDING)}>
        Set As Pending
      </Button>
    </Box>
  );

  const ActiveView = (
    <Box sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', width: '100%', gap: 1, flexWrap: 'wrap' }}>
      <Button variant="contained" onClick={() => updateRecurringPayable(rpInfoForm)} disabled={!isDirty}>
        Save
      </Button>
    </Box>
  );

  if (effectiveStatus === 'CANCELLED' || effectiveStatus === 'DENIED') return null;

  const view =
    effectiveStatus === 'PENDING' || effectiveStatus === 'ON HOLD'
      ? PendingOrHoldView
      : effectiveStatus === 'DENIED'
      ? DeniedView
      : effectiveStatus === 'ACTIVE'
      ? ActiveView
      : DraftView;

  return <>{view}</>;
};

export default RecurringPayableDetailsButtons;
